<div class="root" (click)="emitClick()">
  <div class="title-container">
    <span class="title">{{ title }}</span>

    <div class="arrow">
      <app-lucide-icon [iconName]="'chevron-right'" [size]="16"></app-lucide-icon>
    </div>
  </div>

  <div class="description">
    <span>{{ description }}</span>
  </div>
</div>
